import { css } from "@emotion/css";
import { RadioButtonNew, RadioGroupNew } from "@octopusdeploy/design-system-components";
import { text } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { ExpandableFormSection, Summary } from "~/components/form";
type HelpSidebarFeatureProps = {
    isEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
};
export function HelpSidebarFeature({ isEnabled, onChange }: HelpSidebarFeatureProps) {
    const description = "Enable/disable the contextual help sidebar in the Octopus web-portal UI.";
    const label = "Toggle the Help Sidebar";
    const name = "IsHelpSidebarEnabled";
    return (<ExpandableFormSection key="IsHelpSidebarEnabled" errorKey="IsHelpSidebarEnabled" title={label} summary={isEnabled ? Summary.default("Enabled") : Summary.summary("Disabled")} help={description}>
            <p className={helpSidebarFeatureDescriptionStyles}>
                This feature provides your users with contextual-help to improve their understanding of Octopus' key concepts and includes easy access to the support and documentation resources. Users can dismiss the sidebar themselves.{" "}
                <em>Disabling this feature is not recommended.</em>
            </p>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name} hasDefaultMarker={true}/>
                <RadioButtonNew value={false} label="Disabled" name={name}/>
            </RadioGroupNew>
        </ExpandableFormSection>);
}
const helpSidebarFeatureDescriptionStyles = css({
    font: text.body.regular.large,
});
